<template>
  <div class="container">
    <section class="member">
      <h3>Member</h3>
      <table v-show="currentCustomerMembers.length > 0" class="table">
        <tr>
          <th>Name</th>
          <th>Role</th>
          <th>Email</th>
        </tr>
        <tr v-for="member in currentCustomerMembers" :key="member.id">
          <td>{{ member.name }}</td>
          <td>{{ member.role }}</td>
          <td>{{ member.email }}</td>
        </tr>
      </table>
    </section>
    <section v-show="currentCustomer" class="company">
      <h3>Company</h3>
      <div class="content">
        <span>{{ companyName }}</span>
        <span>{{ streetAddress }}</span>
        <span>{{ postalCode }}</span>
        <span>{{ region }}</span>
        <span>{{ country }}</span>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SubscriptionInfo",
  props: {
    currentCustomer: Object,
    currentCustomerMembers: Array
  },
  computed: {
    streetAddress() {
      if (this.currentCustomer) {
        return this.currentCustomer.address
          ? `${this.currentCustomer.address.houseNumber} ${this.currentCustomer.address.street}`
          : "";
      }
      return "";
    },
    companyName() {
      return this.currentCustomer ? this.currentCustomer.companyName : "";
    },
    postalCode() {
      return this.currentCustomer && this.currentCustomer.address
        ? this.currentCustomer.address.postalCode
        : "";
    },
    region() {
      return this.currentCustomer && this.currentCustomer.address
        ? this.currentCustomer.address.region
        : "";
    },
    country() {
      return this.currentCustomer && this.currentCustomer.address
        ? this.currentCustomer.address.country
        : "";
    },
    ...mapState({
      currentUser: state => state.currentUser
    })
  },
  data() {
    return {
      members: [
        {
          id: "1",
          name: "Michael Scharf",
          role: "Solutions Architect",
          email: "michael.scharf@eos.de"
        },
        {
          id: "2",
          name: "Name",
          role: "Title",
          email: "Email"
        },
        {
          id: "3",
          name: "Name",
          role: "Title",
          email: "Email"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.container {
  display: flex;
  align-self: center;
  padding-left: $p4;

  h3 {
    margin: 0;
    font-size: 18px;
    color: $textColor;
    font-weight: 700;
    margin-bottom: $m4;
    margin-top: $m4;
  }

  & > section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }

  & > .member {
    width: 65%;
    margin-right: $m4;

    & > .table {
      width: 100%;
      background: $white;
      margin-bottom: $m4;

      & > tr {
        color: $textColor;
        border: 1px solid #b2bbc8;
        text-align: left;
        & > th {
          font-weight: 700;
        }
        & > td:first-child,
        & > th:first-child {
          padding-left: $p4;
        }
        & > td,
        & > th {
          padding-top: $p2;
          padding-bottom: $p2;
        }
      }

      @media screen and (max-width: $MobileMaxWidth) {
        width: 100%;
        background: $white;
        margin-bottom: $m4;
        display: block;
        overflow-x: auto;
        white-space: nowrap;

        & > tr {
          color: $textColor;
          border: 1px solid #b2bbc8;
          text-align: left;
          & > th {
            font-weight: 700;
          }
          & > td:first-child,
          & > th:first-child {
            padding-left: $p4;
          }
          & > td,
          & > th {
            padding-top: $p2;
            padding-bottom: $p2;
            padding-right: $p2;
            width: 54px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
    @media screen and (max-width: $MobileMaxWidth) {
      width: 100%;
    }
  }
  & > .company {
    width: 35%;
    margin-bottom: $m4;
    & .content {
      display: flex;
      flex-direction: column;
      background: $white;
      width: 80%;
      align-items: flex-start;
      padding-left: $p2;
      padding-bottom: $p2;
      margin-top: 0;
      height: 200px;
      font-size: $textSmall;
      color: $textColor;

      & span {
        text-align: left;
        max-width: 240px;
      }
    }

    @media screen and (max-width: $MobileMaxWidth) {
      width: 100%;
    }
  }

  @media screen and (max-width: $MobileMaxWidth) {
    flex-direction: column;
    padding-right: $p4;
  }
}
</style>
